import { render, staticRenderFns } from "./ImportLeagueGames.vue?vue&type=template&id=8fd68f40"
import script from "./ImportLeagueGames.vue?vue&type=script&lang=js"
export * from "./ImportLeagueGames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports